var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59642 0 0 5.59642 0 12.5C0 19.4036 5.59642 25 12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59642 19.4036 0 12.5 0ZM12.5 2.41935C18.0712 2.41935 22.5806 6.92797 22.5806 12.5C22.5806 18.0712 18.072 22.5806 12.5 22.5806C6.92883 22.5806 2.41935 18.072 2.41935 12.5C2.41935 6.92883 6.92797 2.41935 12.5 2.41935ZM19.5667 8.98523L18.4308 7.84017C18.1956 7.60302 17.8127 7.60146 17.5755 7.83674L10.4509 14.9041L7.4372 11.8659C7.20197 11.6288 6.819 11.6272 6.58185 11.8624L5.43674 12.9983C5.1996 13.2336 5.19803 13.6165 5.43332 13.8537L10.009 18.4664C10.2442 18.7036 10.6272 18.7051 10.8643 18.4699L19.5634 9.84063C19.8005 9.60534 19.802 9.22238 19.5667 8.98523Z",
    fill: "url(#paint0_linear_1476_29902)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1476_29902",
    x1: -0.00000245858,
    y1: -34.836,
    x2: 31.9912,
    y2: -31.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91D8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#97B1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#F7D780"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8dfde113ec2a31711c70d08f51979f58.svg";
export { ForwardRef as ReactComponent };